import { useEffect } from 'react';

import { useSnackbar } from 'notistack';

import useAxios from 'hooks/api/useAxios';
import { MapTemplateList } from 'types/api/mapTemplateList';

type UseGetTemplateReturn = {
    templates?: MapTemplateList[];
    loading: boolean;
    getAllTemplates: () => void;
};

export const useGetTemplate = (): UseGetTemplateReturn => {
    const { enqueueSnackbar } = useSnackbar();

    const [res, { rerun }] = useAxios<MapTemplateList[]>(
        {
            url: '/api/builder/map/template/',
            method: 'GET',
            skipRequest: () => true,
        },
        []
    );

    const error = res.type === 'error';
    const loading = res.type === 'loading';

    const getAllTemplates = (): void => {
        rerun();
    };

    useEffect(() => {
        if (error) {
            enqueueSnackbar(
                'Что-то пошло не так... Не удалось получить список всех шаблонов.',
                { variant: 'error', key: 'page-list-error' }
            );
        }
    }, [error, enqueueSnackbar]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (error) {
                getAllTemplates();
            }
        }, 3000);
        return () => {
            clearTimeout(timeout);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);

    return {
        templates: res.type === 'success' ? res.data : undefined,
        loading,
        getAllTemplates,
    };
};
